export default __webpack_public_path__ + "static/media/gallery_06.fe509e1f.jpg";